import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import AuthLayout from 'layouts/AuthLayout'
import ResetPassword from 'components/PageComponents/Auth/ResetPassword'

const ResetPasswordPage = () => (
  <>
    <Helmet>
      <title>Skefto: Reset Password</title>
    </Helmet>
    <AuthLayout>
      <ResetPassword />
    </AuthLayout>
  </>
)

export default ResetPasswordPage
